export const MENU_ITEMS = [
  {
    key: 'dashboard',
    icon: 'iconamoon:home-duotone',
    label: 'Dashboard',
    url: '/dashboard',
    requiredPermissions: ['dashboard.read'],
  },

  { key: 'divider-1', isDivider: true },

  {
    key: 'users',
    icon: 'iconamoon:profile-duotone',
    label: 'Users',
    url: '/users',
    requiredPermissions: ['user.read'],
  },
  {
    key: 'referrals',
    icon: 'bx:share-alt',
    label: 'Referrals',
    url: '/referrals',
    requiredPermissions: ['user.read'],
  },
  {
    key: 'transactions',
    icon: 'bx:transfer-alt',
    label: 'Transactions',
    url: '/transactions',
    requiredPermissions: ['transaction.read'],
  },
  {
    key: 'investments',
    icon: 'bx:trending-up',
    label: 'Investments',
    url: '/investments',
    requiredPermissions: ['investment.read'],
  },

  {
    key: 'bank-statement',
    icon: 'bx:building-house',
    label: 'Bank Statement',
    url: '/bank-statement',
    requiredPermissions: ['bank_statement.read'],
  },

  { key: 'divider-2', isDivider: true },

  {
    key: 'support',
    icon: 'bx:message-dots',
    label: 'Support Tickets',
    url: '/support',
    requiredPermissions: ['support.read'],
  },
  {
    key: 'reconciliation',
    icon: 'bx:git-compare',
    label: 'Reconciliation',
    url: '/reconciliation',
    requiredPermissions: ['reconciliation.read'],
  },

  { key: 'divider-3', isDivider: true },

  {
    key: 'sanduk-coins',
    icon: 'bx:coin-stack',
    label: 'Sanduk Coins',
    url: '/rewards/sanduk-coins',
    requiredPermissions: ['rewards.read'],
  },
  {
    key: 'offers',
    icon: 'bx:purchase-tag',
    label: 'Promotional Offers',
    url: '/offers',
    requiredPermissions: ['offers.view'],
  },
  {
    key: 'rewards',
    icon: 'bx:gift',
    label: 'Rewards',
    url: '/rewards',
    requiredPermissions: ['rewards.read'],
  },
  {
    key: 'cms',
    icon: 'bx:file-blank',
    label: 'CMS',
    url: '/cms',
    requiredPermissions: ['cms.read', 'cms.view'],
  },
  {
    key: 'notifications',
    icon: 'bx:bell',
    label: 'Notifications',
    url: '/notifications/campaigns',
    requiredPermissions: ['notifications.read'],
  },

  { key: 'divider-4', isDivider: true },

  {
    key: 'admin-users',
    icon: 'bx:shield-quarter',
    label: 'Admin Users',
    url: '/rbac',
    requiredPermissions: ['rbac.read'],
  },

  { key: 'divider-5', isDivider: true },

  {
    key: 'audit-logs',
    icon: 'bx:list-check',
    label: 'Audit Logs',
    url: '/audit-logs',
    requiredPermissions: ['audit.read'],
  },
];

/** Shown in the sidebar while pathname starts with /whatsapp */
export const WHATSAPP_MENU_ITEMS = [
  {
    key: 'wa-back',
    icon: 'bx:left-arrow-alt',
    label: 'Back',
    url: '/dashboard',
  },
  {
    key: 'wa-dashboard',
    icon: 'solar:chart-2-line-duotone',
    label: 'Dashboard',
    url: '/whatsapp/dashboard',
    requiredPermissions: ['WHATSAPP_DASHBOARD', 'WHATSAPP'],
  },
  {
    key: 'wa-templates',
    icon: 'solar:document-text-line-duotone',
    label: 'My Template',
    url: '/whatsapp/templates',
    requiredPermissions: ['WHATSAPP_TEMPLATE', 'WHATSAPP'],
  },
  {
    key: 'wa-campaigns',
    icon: 'solar:plain-2-line-duotone',
    label: 'My Campaign',
    url: '/whatsapp/campaigns',
    requiredPermissions: ['WHATSAPP_CAMPAIGN', 'WHATSAPP'],
  },
  {
    key: 'wa-inbox',
    icon: 'solar:letter-unread-line-duotone',
    label: 'Inbox',
    url: '/whatsapp/inbox',
    requiredPermissions: ['WHATSAPP_INBOX', 'WHATSAPP'],
  },
  {
    key: 'wa-phonebooks',
    icon: 'mdi:card-account-phone-outline',
    label: 'Phonebook',
    url: '/whatsapp/phonebooks',
    requiredPermissions: ['WHATSAPP_PHONEBOOK', 'WHATSAPP'],
  },
  {
    key: 'wa-settings',
    icon: 'solar:settings-line-duotone',
    label: 'Settings',
    url: '/whatsapp/settings',
    requiredPermissions: ['WHATSAPP'],
  },
];
